import React from 'react'
import PropTypes from 'prop-types'

export default class Input extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onFocus: PropTypes.func,
    inputRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  static defaultProps = {
    required: false,
    disabled: false
  }

  handleChange = (e) => {
    const { label } = Array.from(e.target.options || [])
      .find(({ selected }) => selected === true) || {}

    this.props.onChange(this.props.name, $(e.target).val(), label)
  }
}
